/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  ListUserDeactivationsOptions,
  ListUserDeactivationsStatus200,
  ListUserDeactivationsStatus400,
  ListUserDeactivationsStatus403,
  ListUserDeactivationsStatus500,
} from '../types/ListUserDeactivations'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listUserDeactivations } from '../clients/listUserDeactivations'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listUserDeactivationsQueryKey = ({
  query,
}: Omit<ListUserDeactivationsOptions, 'headers'> = {}) =>
  [{ url: '/v1/user/deactivations' }, ...(query ? [query] : [])] as const

type ListUserDeactivationsQueryKey = ReturnType<typeof listUserDeactivationsQueryKey>

export function listUserDeactivationsQueryOptions(
  { query }: ListUserDeactivationsOptions = {},
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = listUserDeactivationsQueryKey({ query })
  return queryOptions<
    ListUserDeactivationsStatus200,
    ResponseErrorConfig<
      | ListUserDeactivationsStatus400
      | ListUserDeactivationsStatus403
      | ListUserDeactivationsStatus500
    >,
    ListUserDeactivationsStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listUserDeactivations({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Returns each user's latest deactivation request, i.e. their current status. Users with no deactivation history are absent. Ordered by request creation time, newest first. Integrators only see users of their own tenant, unless that tenant is global.
 * @summary Get the current deactivation status across all users (admin, integrator)
 * {@link /v1/user/deactivations}
 */
export function useListUserDeactivations<
  TData = ListUserDeactivationsStatus200,
  TQueryData = ListUserDeactivationsStatus200,
  TQueryKey extends QueryKey = ListUserDeactivationsQueryKey,
>(
  {
    query,
  }: {
    query?: ListUserDeactivationsOptions['query'] | (() => ListUserDeactivationsOptions['query'])
  } = {},
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListUserDeactivationsStatus200,
        ResponseErrorConfig<
          | ListUserDeactivationsStatus400
          | ListUserDeactivationsStatus403
          | ListUserDeactivationsStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? listUserDeactivationsQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...listUserDeactivationsQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | ListUserDeactivationsStatus400
      | ListUserDeactivationsStatus403
      | ListUserDeactivationsStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
